<script>

    export let filter_data;
    export let index;

    export let data;

    console.log(data)


</script>


<section class="card_container">

    <div class="wrapper">

        <div class="logo">
            <img src="{data[1]['img']}" alt="">
        </div>
        <div class="meta-data">
            <h2>{data[1]['job-title']}</h2>
            <span>{data[1]['occupation']}</span>
            <span>{data[1]['salary']}</span>
        </div>

        <div class="headline">
            <h2>{data[1]['headline']}</h2>
            <img src="assets/svgs/info.svg" alt="">
        </div>

        <div class="content">
            <span>{data[1]['text']}</span>
        </div>


    </div>

</section>

<style>
    .card_container  {
        display: flex;
        justify-content: center;
        position: relative;
        height: 90%;
        width: 90%;
        padding-top: 8vw;

    }
    .wrapper {
        border: 1px solid black;
        border-radius: 2vh;
        background-color: white;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 5vw;
    }
    .logo {
        margin-top: 6vw;
        margin-bottom: 6vw;

    }
    .logo img {

    }
    .meta-data {
        display: flex;
        flex-direction: column;
        align-items: center;

    }
    .meta-data span {
        font-size: 3.5vw;
        font-weight: 500;
        margin: 1vw 0;

    }
    .headline {
        margin-top: 4vw;
        display: flex;
    }
    .headline img {
        margin-left: 3vw;
    }
    .content {
        margin-top: 4vw;
        max-height: 55vw;
        white-space: pre-line;


    }
    .content span {
        line-height: 6vw;
        font-weight: 400;
        height: 100%;
        text-overflow:ellipsis;
        overflow:hidden;
        display: -webkit-box !important;
        -webkit-line-clamp: 7;
        -webkit-box-orient: vertical;
        white-space: normal;

    }
    h2 {
        font-size: 5vw;
        font-weight: 600;
        margin: 0;
    }

</style>